/* sb-collection.js — client-side filter (op product-type) + custom sorteer-dropdown voor de shop.
   Alle producten staan server-side in de DOM; we tonen/verbergen + herordenen alleen.
   Progressive enhancement: zonder JS toont de grid alles in de standaardvolgorde. */
(function () {
  function initBar(bar) {
    var section = bar.closest('.sb-coll');
    if (!section) return;
    var grid = section.querySelector('[data-sb-grid]');
    if (!grid) return;
    var cells = Array.prototype.slice.call(grid.querySelectorAll('.sb-coll__cell'));
    var pills = Array.prototype.slice.call(bar.querySelectorAll('[data-sb-filter]'));
    var empty = section.querySelector('[data-sb-empty]');
    // Vaste standaard-volgorde uit de back-end (bepaalt wat 'Aanbevolen' toont): featured | koffie-first | accessoire-first
    var baseOrder = bar.getAttribute('data-sb-order') || 'featured';

    // Custom sorteer-dropdown
    var sel = bar.querySelector('[data-sb-select]');
    var selBtn = sel && sel.querySelector('[data-sb-select-btn]');
    var selMenu = sel && sel.querySelector('[data-sb-select-menu]');
    var selCurrent = sel && sel.querySelector('[data-sb-select-current]');
    var opts = sel ? Array.prototype.slice.call(sel.querySelectorAll('[role="option"]')) : [];

    function sortMode() {
      var a = sel && sel.querySelector('[role="option"][aria-selected="true"]');
      return a ? a.getAttribute('data-value') : 'featured';
    }
    function activeFilter() {
      var a = bar.querySelector('[data-sb-filter].is-active');
      return a ? a.getAttribute('data-sb-filter') : 'all';
    }

    function apply() {
      var f = activeFilter();
      var shown = 0;
      cells.forEach(function (c) {
        var match = f === 'all' || c.getAttribute('data-sb-ptype') === f;
        c.hidden = !match;
        if (match) shown++;
      });
      var mode = sortMode();
      var visible = cells.filter(function (c) { return !c.hidden; });
      visible.sort(function (a, b) {
        if (mode === 'price-asc') return (+a.dataset.sbPrice) - (+b.dataset.sbPrice);
        if (mode === 'price-desc') return (+b.dataset.sbPrice) - (+a.dataset.sbPrice);
        if (mode === 'name-asc') return (a.dataset.sbName || '').localeCompare(b.dataset.sbName || '', 'nl', { sensitivity: 'base' });
        // 'featured' (Aanbevolen) = de in de back-end ingestelde vaste volgorde (groepen op rang)
        var rankOrder = null;
        if (baseOrder === 'abonnement-first') rankOrder = ['abonnement', 'koffie', 'accessoire'];
        else if (baseOrder === 'koffie-first') rankOrder = ['koffie', 'accessoire'];
        else if (baseOrder === 'accessoire-first') rankOrder = ['accessoire', 'koffie'];
        if (rankOrder) {
          var ra = rankOrder.indexOf(a.dataset.sbGroup); if (ra === -1) ra = rankOrder.length;
          var rb = rankOrder.indexOf(b.dataset.sbGroup); if (rb === -1) rb = rankOrder.length;
          if (ra !== rb) return ra - rb;
        }
        return (+a.dataset.sbIndex) - (+b.dataset.sbIndex);
      });
      visible.forEach(function (c) { grid.appendChild(c); });
      if (empty) empty.hidden = shown !== 0;
    }

    // Filter-pills
    pills.forEach(function (p) {
      p.addEventListener('click', function () {
        pills.forEach(function (x) { x.classList.remove('is-active'); x.setAttribute('aria-pressed', 'false'); });
        p.classList.add('is-active');
        p.setAttribute('aria-pressed', 'true');
        apply();
      });
    });

    // Dropdown open/dicht
    if (sel && selBtn && selMenu) {
      var open = function () { selMenu.hidden = false; selBtn.setAttribute('aria-expanded', 'true'); };
      var close = function () { selMenu.hidden = true; selBtn.setAttribute('aria-expanded', 'false'); };
      selBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        if (selMenu.hidden) open(); else close();
      });
      opts.forEach(function (o) {
        o.addEventListener('click', function () {
          opts.forEach(function (x) { x.setAttribute('aria-selected', 'false'); });
          o.setAttribute('aria-selected', 'true');
          if (selCurrent) selCurrent.textContent = o.textContent;
          close();
          apply();
        });
      });
      document.addEventListener('click', function (e) {
        if (!sel.contains(e.target)) close();
      });
      sel.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { close(); selBtn.focus(); }
      });
    }

    // Standaard-volgorde (back-end) meteen toepassen bij laden.
    apply();
  }

  document.querySelectorAll('[data-sb-collbar]').forEach(initBar);
})();
